/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Marienschule_Fulda2Inputs */

const en__field_enum_marienschule_fulda2 = /** @type {(inputs: _Field_Enum_Marienschule_Fulda2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fulda`)
};

const de__field_enum_marienschule_fulda2 = /** @type {(inputs: _Field_Enum_Marienschule_Fulda2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marienschule`)
};

/**
* | output |
* | --- |
* | "Fulda" |
*
* @param {_Field_Enum_Marienschule_Fulda2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_marienschule_fulda2 = /** @type {((inputs?: _Field_Enum_Marienschule_Fulda2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Marienschule_Fulda2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_marienschule_fulda2(inputs)
	return de__field_enum_marienschule_fulda2(inputs)
});
export { _field_enum_marienschule_fulda2 as "_field_enum_Marienschule_Fulda" }